export enum DeathRecordSettlementStatusIdEnum {
  Pending = 1,
  Linked = 2,
  InFlight = 3,
  Paid = 4,
  Transferred = 5,
  Recovered = 6,
  Resolved = 7
}
